@if (legData().transitRoute; as transitRoute) {
  <ng-container
    *ngTemplateOutlet="
      pointTemplate;
      context: {
        address: transitRoute.from.address,
        type: transitRoute.type,
        label: 'labels.start',
      }
    "
  ></ng-container>

  <app-route-point-route-summary
    [routeSummary]="legData().summary"
    [index]="index()"
    [legType]="leg().type"
    [isFirstLeg]="isFirstLeg()"
  ></app-route-point-route-summary>

  <ng-container
    *ngTemplateOutlet="
      pointTemplate;
      context: {
        address: transitRoute.to.address,
        type: transitRoute.type,
        label: 'labels.end',
      }
    "
  ></ng-container>
} @else {
  <div class="summary">
    <app-route-point-route-summary
      [routeSummary]="routeSummary() ?? legData().summary"
      [realizationCompliance]="realizationCompliance()"
      [index]="index()"
      [subpoints]="subpoints()"
      [subpointsExpanded]="subpointsExpanded()"
      [showBordersButton]="showBordersButton()"
      [(bordersExpanded)]="bordersExpanded"
      [isFirstLeg]="isFirstLeg()"
      (hasRealizationChange)="hasRealization.set($event)"
    ></app-route-point-route-summary>

    @if (showBordersButton() && !hasRealization()) {
      <onyx-button variant="transparent" [size]="24" (click)="toggleBorders()">
        <onyx-icon
          class="f-muted"
          name="border-crossing-filled"
          [size]="16"
        ></onyx-icon>

        <onyx-icon
          class="f-muted"
          [name]="
            bordersExpanded()
              ? 'arrow-alt-up-outlined'
              : 'arrow-alt-down-outlined'
          "
          [size]="16"
        ></onyx-icon>
      </onyx-button>
    }
  </div>

  @if (bordersExpanded()) {
    @for (border of leg().passthroughs; track border) {
      <app-route-point-border [border]="border"></app-route-point-border>
    }
  }
}

<ng-template
  #pointTemplate
  let-address="address"
  let-type="type"
  let-label="label"
>
  <div class="point">
    <onyx-address
      class="f-heading-s"
      [address]="address"
      format="city-flag"
    ></onyx-address>

    <div class="details f-muted">
      {{ `${DictionaryCode.ORDER_POINT_TYPE}.${type}` | translate }}

      <span>·</span>

      {{ label | translate }}
    </div>
  </div>
</ng-template>
